export const AdminBillingRoute = '/settings/admin/billing';
export const AdminOverviewRoute = '/settings/admin/overview';
export const CancelAccountRoute = `${AdminBillingRoute}/cancelaccount`;
export const ConvertFreeTrialRoute = `${AdminBillingRoute}/convertfreetrial`;
export const CreditCardOverdueInvoicesRoute = '/creditcardoverdue/invoices';
export const CreditCardOverdueRoute = '/creditcardoverdue';
export const CreditCardOverduePayRoute = `${CreditCardOverdueRoute}/pay`;
export const CreditCardOverduePayStatusRoute = `${CreditCardOverdueRoute}/pay/status`;
export const DashboardRoute = '/dashboard';
export const EditBillingInfoRoute = `${AdminBillingRoute}/editbillinginfo`;
export const ExpirationRoute = '/expiration';
export const ExpirationPurchaseRoute = `${ExpirationRoute}/purchase`;
export const InvoiceOverdueRoute = '/invoiceoverdue';
export const InvoiceOverdueInvoicesRoute = `${InvoiceOverdueRoute}/invoices`;
export const ManagePlanRoute = `${AdminBillingRoute}/manageplan`;
export const ReactivateRoute = `${AdminBillingRoute}/reactivate`;
export const ReceiptsRoute = `${AdminBillingRoute}/viewreceipts`;
